export const maximumRatingAmount = 5;
